// src/app/klipV3Devri.ts
//
// AKIŞ KLİBİNİ V3 TAM EKRANA DEVRET (P0-1'in uygulama yarısı).
//
// Karar `klipAcmaKarari.ts`te (SAF); burada o kararın YAN ETKİLERİ var.
// İkisi bilerek ayrı: karar tarayıcısız kanıtlanır, devir ise gerçek
// `history`/taşıyıcı üzerinden ölçülür. `App.tsx` içinde satır-içi kalsaydı
// ölçmenin tek yolu bütün `App` ağacını (firebase, auth, harita, …) ayağa
// kaldırmak olurdu; o da ürünü değil harness'ı ölçen bir kapı üretirdi.
//
// ⚠️ KİLİTLİ ALANA DOKUNMAZ: burada yapılan tek şey `FeedContainerV3`ün
// ZATEN OKUDUĞU taşıyıcıyı (`pendingV3Anchor`) yazmak ve sayfayı çevirmek.
// Oynatma/pager/poster mantığına (15 değişmez) tek satır girmiyor.

import { setPendingV3Anchor } from "../myclipsv3/feed/pendingV3Anchor";
import type { KlipAcmaKarari } from "./klipAcmaKarari";
// Şekiller UYDURULMADI, çağrı yerinin sözleşmesinden alındı (`any` yok):
// `App` bu iki setter'ı router'a da AYNI tiplerle geçiyor.
import type { ModalIcerigi } from "./appRouting";
import type { ModalVerisi } from "../store/navigationStore";

export type V3DevirKarari = Extract<KlipAcmaKarari, { hedef: "v3feed" }>;

export type DevirEylemleri = {
  setActivePage: (sayfa: string) => void;
  setModalContent: (icerik: ModalIcerigi) => void;
  setModalData: (veri: ModalVerisi) => void;
  /** Router'ın "bu girişi biz push ettik" bayrağı. */
  pushedByAppRef?: { current: boolean } | null;
  /** Geri tuşu dalının bayrağı (`App`in klip-devri popstate dinleyicisi). */
  devirRef?: { current: boolean } | null;
};

/**
 * Devri uygular.
 *
 * ── URL KARARI (ölçülmüş, tercih değil) ────────────────────────────────────
 * Adres çubuğuna `/c/{id}` BURADA yazılmaz. Sebep `appRouting`in soğuk-yük
 * dalında kayıtlı: `useClipDeepLink` mount'ta `/c/`yi okur ve KAPSAMSIZ bir
 * `mlv3:anchor-clip` yayar; o da scoped oturumu ezip "hep ilk klip"
 * regresyonunu doğurur. Adresi feed'in kendisi yazar (`mlv3:clip-shown` →
 * `replaceState("/c/{id}")`), yani paylaşılabilir URL KAYBOLMAZ, sadece
 * SIRASI değişir.
 *
 * Yine de BİR history girişi push edilir (yol değişmeden): yoksa geri tuşu
 * kullanıcıyı akışa değil uygulamanın dışına götürürdü. Feed o girişi
 * `/c/{id}`ye replace eder → hem geri hedefi hem paylaşılabilir adres olur.
 */
export function v3KlibineDevret(karar: V3DevirKarari, eylemler: DevirEylemleri): void {
  const { setActivePage, setModalContent, setModalData, pushedByAppRef, devirRef } = eylemler;

  setPendingV3Anchor({ clipId: karar.clipId, scopedUid: karar.scopedUid });

  try {
    const yol =
      (typeof window !== "undefined" && window.location && window.location.pathname) || "/";
    window.history.pushState({ mlv3: "clip-devir" }, "", yol);
    if (pushedByAppRef) pushedByAppRef.current = true;
    if (devirRef) devirRef.current = true;
  } catch (_) {
    if (pushedByAppRef) pushedByAppRef.current = false;
  }

  // Üstte duran bir katman varsa (ör. keşfet önizlemesi) kapanır: tam ekran
  // feed'in üstünde bayat bir modal kalmasın.
  setModalContent(null);
  setModalData(null);
  setActivePage("clips");
}

export default v3KlibineDevret;
